import React from 'react';

const ExternalLinkWrapper = ({ url }) => (
  <div style={{ display: 'flex', height: '100vh' }}>
    <iframe title="External" src={url} style={{ width: '100%', height: '100%', border: 'none' }} />
  </div>
);

export default ExternalLinkWrapper;
